import React from "react";
import { NavLink } from "react-router-dom";
import PageHero from "../components/PageHero";

function CleanTabs() {
  return (
    <div className="category-tabs">
      <NavLink end to="/clean-rooms">
        Overview
      </NavLink>
      <NavLink to="/clean-rooms/specifications">Specifications</NavLink>
      <NavLink to="/clean-rooms/projects">Projects</NavLink>
    </div>
  );
}

function CleanRoomsOverview() {
  return (
    <div className="page">
      <PageHero
        title="Clean Rooms"
        subtitle="Modular clean room solutions for pharma, food, electronics and healthcare."
        imagePlaceholder="Clean Room Interior"
      />
      <CleanTabs />

      <section className="section">
        <h2>Typical Applications</h2>
        <div className="two-column">
          <ul className="list">
            <li>Pharma formulation & API plants</li>
            <li>Medical device manufacturing</li>
            <li>Micro-electronics & assembly</li>
            <li>Hospital OT & ICU areas</li>
          </ul>
          <p className="muted">
            ROOFTECH delivers panel-based clean room envelopes: walls, ceilings,
            doors and view panels, integrated with HVAC and filtration partners
            to meet required classifications.
          </p>
        </div>
      </section>
    </div>
  );
}

export function CleanRoomsSpecs() {
  return (
    <div className="page">
      <PageHero
        title="Clean Rooms – Specifications"
        subtitle="Key envelope specifications used to achieve the required class."
        imagePlaceholder="Details / Sections"
      />
      <CleanTabs />

      <section className="section">
        <h2>Envelope Highlights</h2>
        <div className="spec-grid">
          <div>
            <h3>Wall & Ceiling Panels</h3>
            <p>
              Flush, insulated panels with concealed joints and covings for
              smooth cleaning.
            </p>
          </div>
          <div>
            <h3>Doors & View Panels</h3>
            <p>
              Flush doors with drop seals, double-glazed view windows, and
              interlocks.
            </p>
          </div>
          <div>
            <h3>Accessories</h3>
            <p>
              Covings, return air risers, pass boxes and service panels
              integrated into the system.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export function CleanRoomsProjects() {
  return (
    <div className="page">
      <PageHero
        title="Clean Rooms – Projects"
        subtitle="Representative layouts for regulated industries."
        imagePlaceholder="Clean Room Layouts"
      />
      <CleanTabs />

      <section className="section">
        <h2>Sample Use Cases</h2>
        <div className="card-grid">
          <div className="card">
            <h3>Pharma Facility</h3>
            <p>
              Multiple class zones with airlocks, change rooms and corridor
              systems.
            </p>
          </div>
          <div className="card">
            <h3>Medical Devices Plant</h3>
            <p>
              Modular clean rooms with provision for future expansion and
              utility integration.
            </p>
          </div>
          <div className="card">
            <h3>Hospital OT Suite</h3>
            <p>
              Panel-based operating rooms with laminar flow and hygienic
              finishes.
            </p>
          </div>
        </div>
      </section>

      <section className="section section-highlight">
        <h2>Project Gallery</h2>
        <p className="muted" style={{ marginBottom: "0.8rem" }}>
          Scroll to view sample clean room corridors, OTs and production areas.
        </p>

        <div className="image-strip">
          <div className="image-tile">
            <span>Pharma Corridor</span>
          </div>
          <div className="image-tile">
            <span>Class 100,000 Area</span>
          </div>
          <div className="image-tile">
            <span>Operation Theatre</span>
          </div>
          <div className="image-tile">
            <span>Change Room</span>
          </div>
          <div className="image-tile">
            <span>Dispensing Booth</span>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CleanRoomsOverview;
